import { Pipe, PipeTransform } from '@angular/core';
import { translateSearchResultType } from '../mappers/enum-translation-mapper';
import { SearchResultType } from '../components/quick-search/quick-search.model';

@Pipe({
  name: 'translateSearchResultType',
})
export class TranslateSearchResultTypeEnum implements PipeTransform {
  transform(value: any): any {
    if (Array.isArray(value)) {
      value.forEach(element => {
        const enumElement = element as { name: string; index: number };
        enumElement.name = translateSearchResultType(enumElement.index as unknown as SearchResultType);
      });
      return value;
    }
    return translateSearchResultType(value);
  }
}
